import React from 'react';
import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { Feature } from '@/@types/featureSwitch';
import { useSessionTimestamp } from '@/customHooks/useSessionTimestamp.hook';

export const MODAL_DISMISSAL_TIMESTAMP_KEY = 'ADAC_UPSELL_DISMISSED_AT';

export const useADACModal = () => {
  const wohnenPlusADACExperimentEnabled = useFeature(Feature.ADAC_ASSIGMENT);
  const { isWithin: checkIfDismissedAlready, recordNow: recordModalDismissal } =
    useSessionTimestamp(MODAL_DISMISSAL_TIMESTAMP_KEY);
  const [visible, setVisible] = React.useState(() => !checkIfDismissedAlready());

  const hide = () => {
    recordModalDismissal();
    setVisible(false);
  };

  const optimizelyExperimentEnabled = false;
  // TODO: Add the logic verifying if Suchen+ is bought
  //  Suchen+ is a prerequisite in this flow
  const suchenPlusBought = true;
  // FIXME: Implement the call to the backend to verify if the ADAC is already bought
  //  ADAC being already bought should be a hard stop in removing the modal completely
  const hasADACActive = false;
  const hasLatelySeenADACUpsell = checkIfDismissedAlready();

  const shouldShowModal =
    !(hasADACActive || hasLatelySeenADACUpsell) && suchenPlusBought && optimizelyExperimentEnabled;

  return {
    canShowADAC: visible && !hasLatelySeenADACUpsell && (wohnenPlusADACExperimentEnabled || shouldShowModal),
    visible,
    hide,
  };
};
